import React from 'react'

import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

const BankIcon = ({ size = 20, color = '#596379', ...props }) => {
  return (
    <Svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      {...props}
    >
      <G clipPath="url(#clip0_8531_8434)">
        <G clipPath="url(#clip1_8531_8434)">
          <Path
            d="M16.8262 16.6685H2.8274C2.32614 16.6685 1.91602 17.0786 1.91602 17.5798C1.91602 18.0811 2.32614 18.4912 2.8274 18.4912H16.8171C17.3184 18.4912 17.7285 18.0811 17.7285 17.5798C17.7285 17.0786 17.3184 16.6685 16.8171 16.6685H16.8262Z"
            fill="#1C1D1F"
          />
          <Path
            d="M2.9821 8.83052H4.78664V14.0527H3.78411C3.28285 14.0527 2.87273 14.4629 2.87273 14.9641C2.87273 15.4654 3.28285 15.8755 3.78411 15.8755H16.2154C16.7166 15.8755 17.1268 15.4654 17.1268 14.9641C17.1268 14.4629 16.7166 14.0527 16.2154 14.0527H15.3222V9.12216C15.3222 9.02191 15.2949 8.92165 15.2675 8.83052H16.908C17.8559 8.83052 18.2478 7.7642 17.4913 7.26294L14.9212 5.58599L10.5283 2.71513C10.182 2.48729 9.71722 2.48729 9.37089 2.71513L4.97803 5.58599L2.40793 7.26294C1.65148 7.75508 2.04337 8.83052 2.99121 8.83052H2.9821ZM13.5633 8.83052C13.5359 8.92165 13.5086 9.01279 13.5086 9.12216V14.0527H10.9202V8.83052H13.5724H13.5633ZM9.08836 8.83052V14.0527H6.6094V8.83052H9.08836Z"
            fill="black"
          />
        </G>
      </G>
      <Defs>
        <ClipPath id="clip0_8531_8434">
          <Rect
            width={`${size}`}
            height={`${size}`}
            transform="translate(0 0.5)"
          />
        </ClipPath>
        <ClipPath id="clip1_8531_8434">
          <Rect
            width={`${size}`}
            height={`${size}`}
            transform="translate(0 0.5)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default BankIcon
